import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../UserContext";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

const SessionConfig = () => {
  const [configurations, setConfigurations] = useState([]);  // eslint-disable-line no-unused-vars
  const [editableConfigurations, setEditableConfigurations] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    const fetchSessionConfig = async () => {
      try {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}?configuration_type=session`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setConfigurations(data);
          setEditableConfigurations(data.map((config) => ({ ...config }))); // Create a copy for editing
        } else {
          console.error("Failed to fetch session configurations.");
        }
      } catch (error) {
        console.error("Error fetching session configurations:", error);
      }
    };

    fetchSessionConfig();
  }, [user.user_id]);

  const handleInputChange = (index, value) => {
    if (/^\d*$/.test(value)) {
      // Validate numeric input
      const updatedConfigurations = [...editableConfigurations];
      updatedConfigurations[index].configuration_value = value;
      setEditableConfigurations(updatedConfigurations);
    }
  };

  const handleSave = async () => {
    try {
      for (let config of editableConfigurations) {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}/${config.configuration_name}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              configuration_value: config.configuration_value,
            }),
          }
        );

        if (!response.ok) {
          console.error(`Failed to update ${config.configuration_name}`);
        }
      }
      setConfigurations([...editableConfigurations]);
      setIsEditable(false);
    } catch (error) {
      console.error("Error updating configurations:", error);
    }
  };

  // const handleCancel = () => {
  //   // Revert to original values
  //   fetchSessionConfig();
  //   setEditableConfigurations([...configurations]);
  //   setIsEditable(false);
  // };

  const handleCancel = () => {
    // Revert to original values by re-fetching from server
    const fetchSessionConfig = async () => {
      try {
        const response = await fetch(
          `${apiBaseURL}/configurations/${user.user_id}?configuration_type=session`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setConfigurations(data);
          setEditableConfigurations(data.map((config) => ({ ...config }))); // Create a copy for editing
        } else {
          console.error("Failed to fetch session configurations.");
        }
      } catch (error) {
        console.error("Error fetching session configurations:", error);
      }
    };

    fetchSessionConfig();
    setIsEditable(false);
  };

  const toggleEdit = () => {
    setIsEditable(!isEditable);
  };

  return (
    <div className=" p-6 max-w-2xl mx-auto font-gotham">
      <h2 className="font-semibold text-2xl text-gray-800 mb-6 border-b pb-2">
        Session Configuration
      </h2>

      <div className="space-y-4">
        {editableConfigurations.map((config, index) => (
          <div key={config.configuration_name} className="flex flex-col">
            <label className="text-gray-700 font-medium mb-1">
              {config.configuration_name}:
            </label>
            <input
              type="text"
              value={config.configuration_value}
              onChange={(e) => handleInputChange(index, e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent transition-all"
              disabled={!isEditable}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        {!isEditable ? (
          <button
            onClick={toggleEdit}
            className="bg-teal-400 text-white w-full py-1 rounded-md shadow-md hover:bg-teal-500 transition-all"
          >
            Edit
          </button>
        ) : (
          <>
            <button
              onClick={handleSave}
              className="bg-teal-400 text-white px-5 py-2 rounded-md shadow-md hover:bg-teal-500 transition-all"
            >
              Save
            </button>
            <button
              onClick={handleCancel}
              className="bg-gray-300 text-gray-700 px-5 py-2 rounded-md shadow-md hover:bg-gray-400 transition-all"
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SessionConfig;
